import axios from "axios";
import moment from "moment";
import { mapAgeAndBeddingFn } from "../utils/functions";

const myStaysAPI = {
  getClientSession({ key, secret }) {
    return axios({
      method: "POST",
      data: {
        key,
        secret,
      },
      url: "https://idp.tripla.ai/api/client_sessions",
    });
  },
  getTiers: (hotelID) => {
    return axios({
      method: "GET",
      url: `https://endpoint.tripla.ai/hotels/${hotelID}/tiers`,
    });
  },

  getInventory(params) {
    return axios({
      method: "GET",
      url: `https://endpoint.tripla.ai/hotels/${
        params.hotelID
      }/rooms/inventory?${new URLSearchParams(params.q)}`,
    });
  },

  getInventoryList(payload, kidTiers = []) {
    const { year, month, roomList } = payload;
    let result = [];

    payload.q.adults = roomList[0].adults.number;
    payload.q.children = roomList[0].children.childrenList.length;
    const kids_age_range = mapAgeAndBeddingFn(
      payload.roomList[0].children.childrenList,
      kidTiers
    );
    const childrenCount = kids_age_range.reduce(
      (acc, cur) => acc + cur.count,
      0
    );
    for (let item = 0; item < 2; item++) {
      if (month < 12) {
        payload.q.checkin_date = moment(new Date(year, month + item, 1)).format(
          "YYYY/MM/DD"
        );
        payload.q.checkout_date = moment(
          new Date(year, month + item + 1, 0)
        ).format("YYYY/MM/DD");
        result.push(
          this.getInventory({
            ...payload,
            q: {
              q: JSON.stringify({
                year_month: `${year}/${month + 1}`,
                start_date: payload.q.checkin_date,
                nights: 1,
                end_date: payload.q.checkout_date,
                checkout_date: payload.q.checkout_date,
                checkin_date: payload.q.checkin_date,
                rooms: [
                  {
                    adults: payload.roomList[0].adults.number,
                    children: childrenCount,
                    kids_age_range
                  },
                ],
              }),
            },
          })
        );
      } else {
        payload.q.checkin_date = new Date(year + 1, month + item, 1);
        payload.q.checkout_date = new Date(year, month + item + 1, 0);
        const kids_age_range = mapAgeAndBeddingFn(
          payload.roomList[0].children.childrenList,
          kidTiers
        );
        const childrenCount = kids_age_range.reduce(
          (acc, cur) => acc + cur.count,
          0
        );
        result.push(
          this.getInventory({
            ...payload,
            q: {
              q: JSON.stringify({
                year_month: `${year}/${month + 1}`,
                start_date: payload.q.checkin_date,
                nights: 1,
                end_date: payload.q.checkout_date,
                checkout_date: payload.q.checkout_date,
                checkin_date: payload.q.checkin_date,
                rooms: [
                  {
                    adults: payload.roomList[0].adults.number,
                    children: childrenCount,
                    kids_age_range,
                  },
                ],
              }),
            },
          })
        );
      }
    }

    return Promise.all(result);
  },
};

export default myStaysAPI;
